import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { css } from "styled-components";

Object.assign(logoStyles, {
    ...logoStyles,
    wrapper: {
        css: css`
            max-width: auto;
            max-height: auto;
        `,
    },
});
